import { render, staticRenderFns } from "./CategoryLinksManager.vue?vue&type=template&id=e579854e&"
import script from "./CategoryLinksManager.vue?vue&type=script&lang=js&"
export * from "./CategoryLinksManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports